import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, renderSlot as _renderSlot, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-67008af0")

_pushScopeId("data-v-67008af0")
const _hoisted_1 = {
  key: 0,
  class: "checkbox__checkmark"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("svg", {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "#fff"
}, [
  /*#__PURE__*/_createVNode("path", { d: "M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" })
], -1)
const _hoisted_3 = { class: "checkbox__input" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", {
    class: ["checkbox", {
    'checkbox--checked': _ctx.checked,
    'checkbox--light': _ctx.inactive && _ctx.checked
  }]
  }, [
    _createVNode("div", {
      class: "checkbox__box",
      onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggle && _ctx.toggle(...args)), ["prevent","stop"]))
    }, [
      (_ctx.checked)
        ? (_openBlock(), _createBlock("div", _hoisted_1, [
            _hoisted_2
          ]))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_3, [
        _createVNode("input", {
          type: "checkbox",
          value: _ctx.value,
          checked: _ctx.checked
        }, null, 8, ["value", "checked"])
      ])
    ]),
    _createVNode("label", {
      class: ["checkbox__label", {
            'checkbox__label--excluded': !_ctx.checked,
            'checkbox__label--bold': _ctx.checked && !_ctx.inactive
        }],
      onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggle && _ctx.toggle(...args)), ["prevent","stop"]))
    }, [
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ], 2)
  ], 2))
})